import { useCallback } from 'react';
import { type Editor } from '@tiptap/react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { EquationIcon } from '@/icons';
import { MathInline } from '@/shared/features/rich-text';
import { Button } from '@/ui_v3/components/button';
import { openEquationEditorModal } from '../EquationEditorModal';
import { getFormulaReplacementBudget } from '../hook/useBuildTextEditor';
export const EquationButton = ({
  editor,
  className,
  maxLength,
  characterLimit
}: {
  editor: Editor | null;
  className?: string;
  /** 수식 하나의 LaTeX 원문 상한. 넘으면 편집 창의 입력 버튼이 비활성화된다. */
  maxLength?: number;
  /** 수식이 들어가는 칸의 전체 글자 한도. 있으면 편집 창이 남은 글자 수를 안내한다. */
  characterLimit?: number;
}) => {
  const {
    t
  } = useTranslation(['build']);
  const handleInsertEquation = useCallback((latex: string) => {
    // HTML 문자열로 이어 붙이면 LaTeX 의 `"` 가 속성을 깨므로 노드로 넣는다.
    editor?.commands.insertContent({
      type: MathInline.name,
      attrs: {
        latex
      }
    });
  }, [editor]);
  const handleClickEquationButton = useCallback(async () => {
    // 새 수식은 선택 영역을 덮어쓴다(선택이 없으면 커서 자리에 들어간다).
    const latex = await openEquationEditorModal({
      initialValue: '',
      maxLength,
      characterBudget: editor && characterLimit !== undefined ? getFormulaReplacementBudget(editor, editor.state.selection, characterLimit) : undefined
    });
    if (latex) {
      handleInsertEquation(latex);
      logger.track('build_addformula', {
        location: 'question'
      });
    }
  }, [characterLimit, editor, handleInsertEquation, maxLength]);
  return <Button className={className} leftSlot={<EquationIcon size="xs" fill="#7A7B89" />} onMouseDown={e => {
    e.stopPropagation();
  }} onClick={e => {
    e.stopPropagation();
    e.preventDefault();
    void handleClickEquationButton();
  }} variant="transparent" intent={'neutral'} size="xs" data-sentry-element="Button" data-sentry-component="EquationButton" data-sentry-source-file="EquationButton.tsx">
      {t('build:build.equationModal.header')}
    </Button>;
};